import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';
import RadioIcon from '@atlaskit/icon/glyph/radio';
import { HiddenInput, IconWrapper, Label, Wrapper } from './styled/Radio';

var Radio = function (_Component) {
  _inherits(Radio, _Component);

  function Radio() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Radio);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Radio.__proto__ || _Object$getPrototypeOf(Radio)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isHovered: false,
      isFocused: false,
      isActive: false,
      mouseIsDown: false
    }, _this.onBlur = function () {
      return _this.setState({
        // onBlur is called after onMouseDown if the checkbox was focused, however
        // in this case on blur is called immediately after, and we need to check
        // whether the mouse is down.
        isActive: _this.state.mouseIsDown && _this.state.isActive,
        isFocused: false
      });
    }, _this.onFocus = function () {
      return _this.setState({ isFocused: true });
    }, _this.onMouseLeave = function () {
      return _this.setState({ isActive: false, isHovered: false });
    }, _this.onMouseEnter = function () {
      return _this.setState({ isHovered: true });
    }, _this.onMouseUp = function () {
      return _this.setState({ isActive: false, mouseIsDown: false });
    }, _this.onMouseDown = function () {
      return _this.setState({ isActive: true, mouseIsDown: true });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Radio, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          isDisabled = _props.isDisabled,
          isRequired = _props.isRequired,
          isSelected = _props.isSelected,
          name = _props.name,
          onChange = _props.onChange,
          value = _props.value;
      var _state = this.state,
          isFocused = _state.isFocused,
          isHovered = _state.isHovered,
          isActive = _state.isActive;


      return React.createElement(
        Label,
        {
          isDisabled: isDisabled,
          onMouseDown: this.onMouseDown,
          onMouseEnter: this.onMouseEnter,
          onMouseLeave: this.onMouseLeave,
          onMouseUp: this.onMouseUp
        },
        React.createElement(HiddenInput, {
          checked: isSelected,
          disabled: isDisabled,
          name: name,
          onChange: onChange,
          onBlur: this.onBlur,
          onFocus: this.onFocus,
          required: isRequired,
          type: 'radio',
          value: value
        }),
        React.createElement(
          Wrapper,
          null,
          React.createElement(
            IconWrapper,
            {
              isSelected: isSelected,
              isDisabled: isDisabled,
              isFocused: isFocused,
              isActive: isActive,
              isHovered: isHovered
            },
            React.createElement(RadioIcon, {
              primaryColor: 'inherit',
              secondaryColor: 'inherit',
              isHovered: this.state.isHovered,
              isActive: this.state.isActive,
              label: ''
            })
          ),
          React.createElement(
            'span',
            null,
            children
          )
        )
      );
    }
  }]);

  return Radio;
}(Component);

Radio.defaultProps = {
  isDisabled: false,
  isSelected: false
};
export default Radio;